export default "__VITE_ASSET__DQzkaMva__"